import "./assessment-avatar-modal.scss";
import { useSpeechStream } from "@imaginelearning/mps-ux-component-library";
import Growbot from "../growbot/growbot";

interface IAvatarModelProps {
  grade: number;
  title: string;
  text: string;
  show: boolean;
  onHide: () => void;
}

function AvatarModal({ grade, title, text, show, onHide }: IAvatarModelProps) {
  const { play, isPlaying, pause } = useSpeechStream();

  const viewType = grade < 3 ? "gradekto2" : "grade3plus";
  const MODAL_DIALOG_ID = "iplusa-avatar-modal";

  const Play = (
    <svg width="16" height="16" viewBox="0 0 19 22" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.625 0.828125C2.32812 0.40625 3.21875 0.40625 3.92188 0.875L17.4219 9.07812C18.0781 9.5 18.5 10.25 18.5 11C18.5 11.7969 18.0781 12.5469 17.4219 12.9219L3.92188 21.1719C3.21875 21.5938 2.32812 21.6406 1.625 21.2188C0.921875 20.8438 0.5 20.0938 0.5 19.25V2.75C0.5 1.95312 0.921875 1.20312 1.625 0.828125ZM2.75 19.25L16.25 11L2.75 2.75V19.25Z"
        fill="currentColor"
      />
    </svg>
  );

  const GoArrow = (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2249_80)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27 16.4992C27 15.8742 26.6484 15.2492 26.1016 14.8977L14.8516 8.06172C14.2656 7.67109 13.5234 7.67109 12.9375 8.02266C12.3516 8.33516 12 8.96016 12 9.62422V13.9992H5C3.89543 13.9992 3 14.8946 3 15.9992V16.9992C3 18.1038 3.89543 18.9992 5 18.9992H12V23.3742C12 24.0774 12.3516 24.7024 12.9375 25.0149C13.5234 25.3664 14.2656 25.3274 14.8516 24.9758L26.1016 18.1008C26.6484 17.7883 27 17.1633 27 16.4992Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2249_80">
          <rect width="24" height="19" fill="white" transform="translate(3 7)" />
        </clipPath>
      </defs>
    </svg>
  );

  const playAudio = () => {
    if (isPlaying) {
      pause();
    } else {
      play(MODAL_DIALOG_ID);
    }
  };

  return (
    <>
      <div className="backdrop" />
      <div className={`avatar-modal ${viewType} ${show ? "show" : ""}`}>
        <Growbot botstyle="leaf" className="left" />
        <div className="avatar-modal-content" id={MODAL_DIALOG_ID}>
          <div className="avatar-modal-arrow" />{" "}
          <button data-testid="audio-btn" className="btn audio-btn" onClick={playAudio}>
            {Play}
          </button>
          <h1>{title}</h1>
          <p>{text}</p>
          <div className="mt-3">
            <button onClick={onHide} className="btn btn-go">
              Go {GoArrow}{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default AvatarModal;
export type { IAvatarModelProps };
